import { render, staticRenderFns } from "./InputTag.vue?vue&type=template&id=01043760&scoped=true&"
import script from "./InputTag.vue?vue&type=script&lang=js&"
export * from "./InputTag.vue?vue&type=script&lang=js&"
import style0 from "./InputTag.vue?vue&type=style&index=0&id=01043760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01043760",
  null
  
)

export default component.exports